export default {
      id: "trash-usage",
      viewBox: "0 0 21 24",
      url: __webpack_public_path__ + "img/icons.svg#trash",
      toString: function () {
        return this.url;
      }
    }